<script>
	import axios from "axios";
	let list = [];
	let url = "http://m.tea7.com";
	axios
		.post(url + "/Modules/United/ProductListModelule", {
			keys: "2021chuncha",
		})
		.then((res) => {
			list = res.data;
		});
	function toBuy(id) {
		OpenProdcutDetail(id);
		/* console.log(id);
		window.location.href = `/item/${id}.htm`; */
	}
</script>

<main>
	<a href="javascript:history.go(-1);" class="back"
		><i class="iconfont">&#xe625;</i></a
	>
	<a href="/" class="home" id="menu"><i class="iconfont">&#xe60c;</i></a>

	<div class="app">
		<div class="top-title-container">
			<img
				class="top-ab-img"
				src="https://douchasai.oss-cn-shenzhen.aliyuncs.com/20210311101809872.png"
				alt=""
			/>
			<img
				class="top-back"
				src="https://douchasai.oss-cn-shenzhen.aliyuncs.com/20210311101801475.png"
				alt=""
			/>
			<div class="bar" />
		</div>
		{#each list as item, index}
			<div class="goods-item {index === 0 ? 'goods-item-first' : ''}">
				<div class="goods-top {index % 2 != 0 ? 'reverseflex' : ''}">
					<div class="goods-img">
						{#if item.IsSoldOut == true}
							<img
								src="http://imgcon.tea7.com/6367530939134437297024552.png"
								alt="售罄"
								class="nostockimg"
							/>
						{/if}
						<img src={item.PictureUrl} alt="商品图片" />
					</div>
					<div class="goods-info">
						<p class="goods-title">{item.Name}</p>
						<p class="goods-desc">
							{item.ProductShortDescription || ""}
						</p>
						<p class="goods-price">{item.Price}</p>
						{#if item.IsSoldOut == false}
							<img
								on:click={toBuy(item.Id)}
								class="buy-btn"
								alt="购买按钮"
								src="https://douchasai.oss-cn-shenzhen.aliyuncs.com/20210311134357436.png"
							/>
						{:else}
							<div class="nostock buy-btn">已售罄</div>
						{/if}
					</div>
				</div>
			</div>
		{/each}
	</div>
</main>

<style>
	:global(body) {
		margin: 0;
	}
	main {
		text-align: center;
		/* width: 100vw; */
		margin: 0 auto;
		display: flex;
		justify-content: center;
		overflow-x: hidden;
	}
	.app {
		background-color: #5dcfa2;
		padding: 0;
		text-align: center;
		min-width: 375px;
		margin: 0 auto;
		overflow-x: hidden;
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: auto;
		padding-bottom: 20px;
		position:fiexd;z-index:10;-webkit-overflow-scrolling:touch;
	}
	.top-title-container {
		width: 100%;
		position: relative;
		height: auto;
		background-image: url("https://douchasai.oss-cn-shenzhen.aliyuncs.com/20210311101752843.png");
		background-size: 100% 400px;
		background-repeat: no-repeat;
		background-color: #e1faf0;
	}
	.top-back {
		width: 100% !important;
		height: auto;
		position: relative;
		z-index: 2;
		margin-top: 293px;
	}
	.bar {
		background-color: #5dcfa2;
		/* background-color: red; */
		width: 100vw;
		position: absolute;
		bottom: 0;
		left: 0;
		height: 20px;
	}
	.top-ab-img {
		width: 273px;
		height: auto;
		position: absolute;
		margin-top: 140px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1;
		animation: rorate 1.6s linear;
	}
	@keyframes rorate {
		from {
			transform: translateX(-50%) translateY(200px);
			opacity: 0;
		}
		to {
			transform: translateX(-50%) translateY(0px);
			opacity: 1;
		}
	}

	.goods-item-first {
		margin-top: -30px;
		position: relative;
	}
	.goods-item {
		margin-left: 0.5rem;
		margin-right: 0.5rem;
		margin-bottom: 0.4rem;
		display: flex;
		flex-direction: column;
		background-color: #ffffff;
		border-radius: 8px;
		overflow: hidden;
		position: relative;
		z-index: 3;
		box-shadow: 5px 5px 0 #00000030;
	}
	.goods-top {
		width: 100%;
		display: flex;
	}
	.reverseflex {
		flex-direction: row-reverse;
	}
	.goods-img {
		position: relative;
		width: 40%;
		height: 0;
		flex-shrink: 0;
		padding-bottom: 42%;
	}
	.goods-img img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.nostockimg {
		position: absolute;
		z-index: 3;
		width: 80% !important;
		height: 80% !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%);
	}
	.nostock {
		background: #999999 !important;
		color: #ffffff;
		font-size: 0.3rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.goods-info {
		padding: 12px 6px 6px 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: auto;
		flex: 1;
	}
	.goods-title {
		font-size: 18px;
		text-align: left;
		color: #25855c;
		border-bottom: 1px dashed #25855c;
		line-height: 1.2;
		height: 21.6px;
		word-break: break-all;
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}
	.goods-price {
		color: #ff1800;
		font-size: 18px;
		font-weight: bold;
		text-align: left;
	}

	.goods-price::before {
		content: "活动价￥";
		font-size: 12px;
		font-weight: 500;
	}
	.goods-desc {
		text-align: left;
		color: #282828;
		font-size: 15px;
		word-break: break-all;
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		height: 30px;
	}
	.buy-btn {
		border-radius: 5px;
		font-size: 13px;
		background-color: #ff0900;
		color: #ffffff;
		line-height: 1;
		float: left;
		width: 90px;
		height: 25px;
		/* padding: 7px 0.8rem; */
	}
	/*.goods-bottom {
		background-color: #fee2cc;
		padding: 12px 8px;
	}
	.goods-reason {
		font-size: 12px;
		text-align: left;
		color: #666666;
		line-height: 1.4;
	} */
	.home,.back {
		position: absolute;
		top: 5px;
		background: rgba(0, 0, 0, 0.5);
		width: 1rem;
		height: 1rem;
		text-align: center;
		line-height: 1rem;
		color: #fff;
		border-radius: 50%;
		z-index: 11;
	}
	.home{
		right:10px;
	}
	.back{
		left:10px;
	}
</style>
